import React from 'react';
import {Link as Styler} from 'rebass';
import {Link as RouterLink} from 'react-router-dom';


export default props =>
    <Styler {...props} width={1/6} variant='nav' margin='3' fontSize='3' color="white" sx={{textDecoration: 'none', fontWeight: 'bold'}} as={RouterLink} />